import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Badge, Col, Button } from 'reactstrap'

import {
  DOWNLOAD_LESSON_REPORT_TEXT,
  PREPARING_LESSON_REPORT_TEXT,
} from './constants'
import CsvDownloadLink from 'components/CsvDownloadLink'
import ErrorBoundary from 'components/ErrorBoundary'
import TextLink from 'components/TextLink'
import { ButtonWrapper, StyledRow } from './component.styles'

class LicenseHeader extends Component {
  static propTypes = {
    createLessonReportDownloadData: PropTypes.func,
    deleteReports: PropTypes.func,
    fetchLessonProgressReport: PropTypes.func,
    isFetching: PropTypes.bool,
    reportData: PropTypes.array,
    license: PropTypes.object,
    toggleEditModal: PropTypes.func.isRequired,
    skuCode: PropTypes.string.isRequired,
  }

  componentWillUnmount() {
    const { deleteReports } = this.props
    deleteReports()
  }

  getLessonProgressReport = async () => {
    const { fetchLessonProgressReport, license } = this.props
    fetchLessonProgressReport && fetchLessonProgressReport(license)
  }

  render() {
    const {
      isFetching,
      reportData = {},
      license,
      toggleEditModal,
      skuCode,
    } = this.props
    const { getLessonProgressReport } = this

    if (!license) return null

    const { data, filename, headers } = reportData || {}
    const dataExists = data && data.length > 0
    const progressReportLinkText = isFetching
      ? PREPARING_LESSON_REPORT_TEXT
      : DOWNLOAD_LESSON_REPORT_TEXT

    return (
      <ErrorBoundary>
        <StyledRow>
          <Col>
            <h2 className="mt-2 text-light">
              <span className="float-right">
                <ButtonWrapper>
                  {skuCode === 'K8P' && !dataExists && (
                    <TextLink
                      dataTestId="get-lesson-progress-report-link"
                      disabled={isFetching}
                      onClick={getLessonProgressReport}
                    >
                      {progressReportLinkText}
                    </TextLink>
                  )}
                  {skuCode === 'K8P' && dataExists && (
                    <CsvDownloadLink
                      data={data}
                      filename={filename}
                      headers={headers}
                    >
                      {DOWNLOAD_LESSON_REPORT_TEXT}
                    </CsvDownloadLink>
                  )}

                  <Button
                    color="light"
                    onClick={() => toggleEditModal(license)}
                  >
                    <i className="fas fa-pencil-alt" />
                    &nbsp;Edit
                  </Button>
                </ButtonWrapper>
              </span>
              License&nbsp;
              <Badge color="light">SS: {license.id}</Badge>&nbsp;
              <Badge color="light">NS: {license.nsLicenseId}</Badge>
            </h2>
          </Col>
        </StyledRow>
      </ErrorBoundary>
    )
  }
}

export default LicenseHeader



// WEBPACK FOOTER //
// ./src/containers/css-admin/licenses/LicenseHeader/component.jsx